// extracted by mini-css-extract-plugin
module.exports = {"buttons":"AddKioskDialog_buttons__5WR5L","button":"AddKioskDialog_button__33sdz"};